import { QueryKey, useQuery, UseQueryOptions, useMutation } from 'react-query';
import { auditionDao } from 'shared/dao/auditionDao';

import {
  IAttachAuditionMedia,
  IAuditionAttachmentsPayload,
  IAuditionRequestPayload,
  IAuditionResponsePayload,
  IVerifyAudition,
} from 'shared/interfaces/IAudition';
import { ISelfTapesScheduleResponse } from 'shared/interfaces/IAuditionSchedule';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const {
  getAuditions: getAuditionsDao,
  getAuditionAttachements: getAuditionAttachementsDao,
  attachAuditionMedia: attachAuditionMediaDao,
  deleteAuditionMedia: deleteAuditionMediaDao,
  getAudition: getAuditionDao,
  verifyAudition: verifyAuditionDao,
  updateAuditionMedia: updateAuditionMediaDao,
} = auditionDao();
export const auditionService = () => {
  const getAuditions = (
    payload: IAuditionRequestPayload,
    options?: Omit<
      UseQueryOptions<IAuditionResponsePayload, IAxiosErrorResponse, IAuditionResponsePayload, QueryKey>,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useQuery<IAuditionResponsePayload, IAxiosErrorResponse>(
      ['audition', payload],
      () => getAuditionsDao(payload),
      options,
    );
  };

  const getAudition = (id: string) => {
    return useQuery<ISelfTapesScheduleResponse, IAxiosErrorResponse>(
      ['audition_details', id],
      () => getAuditionDao(id),
      { enabled: id !== '' },
    );
  };

  const getAuditionAttachements = (auditionId: string) => {
    return useQuery<IAuditionAttachmentsPayload, IAxiosErrorResponse>(['audition_attachments', auditionId], () =>
      getAuditionAttachementsDao(auditionId),
    );
  };

  const attachAuditionMedia = () => {
    return useMutation(({ auditionId, payload }: { auditionId: string; payload: IAttachAuditionMedia }) =>
      attachAuditionMediaDao(auditionId, payload),
    );
  };

  const updateAuditionMedia = () => {
    return useMutation(
      ({ auditionId, medium_id, payload }: { auditionId: string; medium_id: string; payload: IAttachAuditionMedia }) =>
        updateAuditionMediaDao(auditionId, medium_id, payload),
    );
  };

  const deleteAuditionMedia = () => {
    return useMutation(({ auditionId, mediumId }: { auditionId: string; mediumId: string }) =>
      deleteAuditionMediaDao(auditionId, mediumId),
    );
  };

  const verifyAudition = () => {
    return useMutation((payload: IVerifyAudition) => verifyAuditionDao(payload));
  };

  return {
    updateAuditionMedia,
    verifyAudition,
    getAudition,
    getAuditionAttachements,
    getAuditions,
    attachAuditionMedia,
    deleteAuditionMedia,
  };
};
